import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/matka/rate?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`,{},process.env.REACT_APP_MATKA_BASE_URL
  );
};

export const Update = async (data) => {
  return await PUT(`/admin/matka/rate`, data,process.env.REACT_APP_MATKA_BASE_URL);
};
  